import { BaseList } from "@design-controls/types";
import { createQColumnHelper } from "@qualio/ui-components";
import { formatDesignElementVersion } from "../../domain/designElementVersion";

export function designElementVersionColumn<
  T extends Pick<BaseList, "major" | "minor">,
>(header: string): any {
  return createQColumnHelper<T>().text(
    (record) => formatDesignElementVersion(record.major, record.minor),
    {
      id: "version",
      header,
      maxWidth: "100px",
      enableSorting: false,
    },
  );
}
